package top.wcpe.allincore.ui.runtime.render

/**
 * JS actual：Kotlin/JS 的默认 hashCode() 为实例级（每个对象首次调用时分配并缓存在对象上），
 * 不经 equals 语义，即身份哈希等价物。
 */
internal actual fun identityHashOf(obj: Any): Int = obj.hashCode()
